import React from 'react';
import { NotFoundWrapper } from './styled';

export const NotFound = () => {
  const NOT_FOUND = <NotFoundWrapper>No encontramos la página que buscas.</NotFoundWrapper>;

  return NOT_FOUND;
};
